// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AdditionalServicePrices_RemoverResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de POST /so/additional_service_prices/remover.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AdditionalServicePrices_RemoverResponseDados {
so_additional_service_price_id: number
}

export type AdditionalServicePrices_RemoverResponse = ApiResponse<AdditionalServicePrices_RemoverResponseDados>;

registerResponseContract('AdditionalServicePrices_RemoverResponse', {
  so_additional_service_price_id: { type: 'number',  required: true },
})
